import { useMutation, useQueryClient } from '@tanstack/react-query';

import { reviewQueueKeys } from '@/features/case-reports/hooks';

import { sessionsService } from '../services';

import { sessionsKeys } from './useSessions';

export function useRejectCaseReport(sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { reportId: string; rejectionReason: string }) =>
      sessionsService.rejectCaseReport(sessionId, input.reportId, {
        rejectionReason: input.rejectionReason,
      }),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: sessionsKeys.operation('case-reports', sessionId),
      });
      void qc.invalidateQueries({
        queryKey: sessionsKeys.operation('case-reports-meta', sessionId),
      });
      // Rejection drops the report off the reviewer's queue (status flips
      // to 'rejected', no longer matches the BE filter). Invalidate so
      // the chief who just rejected sees the entry leave their backlog.
      void qc.invalidateQueries({ queryKey: reviewQueueKeys.all });
    },
  });
}
